import api from "../api/axios";

export const getManifests = (params) => {
  if (typeof params === 'string' || !params) {
    return api.get(`/api/manifests/get-manifests`, { params: { branchCode: params } });
  }
  return api.get(`/api/manifests/get-manifests`, { params });
};

export const createManifest = (data) =>
  api.post("/api/manifests/create-manifest", data);

export const updateManifest = (id, data) =>
  api.put(`/api/manifests/update-manifests-status/${id}`, data);
export const getNextManifestNo = () =>
  api.get("/api/manifests/generate-next-manifest-no");
